<template>
    <v-card color="primary" elevation="20">
        <v-text-field v-model="search1" append-icon="search" label=" Search" single-line outline hide-details>
        </v-text-field>
        <v-data-table color="primary" :headers="headers_lvl1" :items="warehouses" :loading="isLoading" :search="search1" :pagination.sync="pagination1" item-key="warehouse_name" class="elevation-1">
            <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded">
                    <td> {{ props.item.warehouse_name }} </td>
                    <td class="text-xs-right"> Click to view parts </td>
                </tr>
            </template>
            <template slot="expand" slot-scope="props">
                <v-card color="primary" elevation="20">
                    <v-data-table :headers="headers_lvl2" :items="props.item.warehouse_data" item-key="Part_Number">
                        <template slot="items" slot-scope="props">
                            <tr @click="props.expanded = !props.expanded">
                                <td> {{props.item.Part_Name}} </td>                                                
                                <td> {{props.item.Part_Number}} </td>
                                <td style="text-align:center" class="text-xs-right"> {{props.item.Qty}} </td>
                                <td class="text-xs-right"> Click to view Serials </td>
                            </tr>
                        </template>
                        <template slot="expand" slot-scope="props">
                            <v-card>
                                <v-card color="primary" :flat="true"> {{formattedSerialList(props.item.Serial_Num)}} </v-card>
                            </v-card>
                        </template>
                    </v-data-table>
                </v-card>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { formatSerialList } from '../../helpers/formatHelpers.js'
    export default {
        name: 'WarehouseStockTable',
        props: {
            warehouses: {
                type: Array,
                required: true
            },
            isLoading : {
                type: Boolean,
                required: true
            },
        },
        data: function () {
            return {
                search1: "",
                headers_lvl1: [
                    {
                    text: "Warehouse",
                    value: "warehouse_name"
                    },
                    {
                    text: "",
                    value: "warehouse_raw_data",
                    sortable: false
                    }
                ],
                headers_lvl2: [
                    {
                    text: "Part Name",
                    value: "Part_Name"
                    },
                    {
                    text: "Part Number",
                    value: "Part_Number"
                    },
                    {
                    text: "Quantity of Part",
                    value: "Qty",
                    align: "right"
                    },
                    {
                    text: "",
                    value: "Serial_Num",
                    sortable: false
                    }
                ],
                pagination1: {
                    sortBy: "warehouse_name"
                },
            }
        },
        methods: {
            formattedSerialList(serials) {
                return formatSerialList(serials)
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/tables/warehouseStockTable.vue